import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Checkbox from '@components/Checkbox';
import FormatPrice from '@shared/containers/FormatPrice';
import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';

const Container = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.productConfiguration.optionRowCheckbox.color};

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  }
`;

const Body = styled.div`
  min-height: 60px;
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-left: 20px;
  padding-right: ${({ theme }) => theme.constants.lateralSpace};
`;

const Name = styled.span`
  max-width: 90%;
  ${({ theme, selected }) =>
    selected &&
    css`
      font-weight: bold;
      color: ${theme.productConfiguration.optionRowCheckbox.selected.color};
    `};
`;

const Price = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
`;

function OptionRowCheckbox({
  name,
  isSelected,
  onSelect,
  amount,
  modifiesPrice,
}) {
  return (
    <Container
      onClick={onSelect}
      onKeyUp={e => onKeyUpFunction(e, onSelect)}
      onKeyDown={e => onKeyDownFunction(e, onSelect)}
      tabIndex={0}
      role="checkbox"
      aria-checked={isSelected}
    >
      <Checkbox selected={isSelected} />
      <Body>
        <Name selected={isSelected}>{name}</Name>
        {amount > 0 && (
          <FormatPrice value={amount}>
            {formattedPrice => (
              <Price>
                {modifiesPrice ? `${formattedPrice}` : `+ ${formattedPrice}`}
              </Price>
            )}
          </FormatPrice>
        )}
      </Body>
    </Container>
  );
}

OptionRowCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  modifiesPrice: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default OptionRowCheckbox;
